// 「常用 / 進階 / 技術」篩選晶片（DEV-07 總表、DEV-08 套設定）：多選，預設常用 + 進階；技術只給 owner / admin。
import { useTranslation } from 'react-i18next';
import { DEFAULT_TIERS, TIERS, type Tier } from './settingsTiers';

export const defaultTierSet = (): Set<Tier> => new Set(DEFAULT_TIERS);

export function TierChips({ value, onChange, canTech }: { value: ReadonlySet<Tier>; onChange(v: Set<Tier>): void; canTech: boolean }) {
  const { t } = useTranslation();
  return (
    <span className="row-inline tier-chips" role="group" aria-label={t('tier.filter')}>
      {TIERS.filter((x) => x !== 'technical' || canTech).map((x) => (
        <button
          key={x}
          type="button"
          className={'chip' + (value.has(x) ? ' on' : '')}
          aria-pressed={value.has(x)}
          data-tier-chip={x}
          onClick={() => {
            const n = new Set(value);
            if (n.has(x)) n.delete(x);
            else n.add(x);
            onChange(n);
          }}
        >
          {t(`tier.${x}`)}
        </button>
      ))}
    </span>
  );
}
